import { Component, DestroyRef, afterNextRender, inject } from '@angular/core';
import {
  AuditResourcesComponent,
  DemoRequestComponent,
  FaqComponent,
  GovernanceComponent,
  HeroComponent,
  ModulesComponent,
  PainPointsComponent,
  PlatformGalleryComponent
} from '../sections';
import { SectionNavigationService } from '../shared';
import { NAV_LINKS } from '../content/home.content';

@Component({
  selector: 'app-home',
  imports: [
    HeroComponent,
    PainPointsComponent,
    ModulesComponent,
    PlatformGalleryComponent,
    GovernanceComponent,
    AuditResourcesComponent,
    FaqComponent,
    DemoRequestComponent
  ],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  constructor() {
    const navigation = inject(SectionNavigationService);
    const destroyRef = inject(DestroyRef);

    afterNextRender(() => {
      const stop = navigation.observe(['hero', ...NAV_LINKS.map(link => link.section), 'faq', 'contato']);
      destroyRef.onDestroy(stop);
    });
  }
}
